<template>
  <span :class="badgeClasses" v-if="visible">
    <slot>{{ value }}</slot>
  </span>
</template>

<script>
export default {
  name: 'UIBadge',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    severity: {
      type: String,
      default: 'primary',
      validator: (value) => ['primary', 'secondary', 'success', 'info', 'warning', 'danger'].includes(value)
    },
    size: {
      type: String,
      default: 'normal',
      validator: (value) => ['small', 'normal', 'large', 'xlarge'].includes(value)
    },
    badgeDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible() {
      return this.value != null || this.$slots.default;
    },
    badgeClasses() {
      const classes = [
        'inline-flex items-center justify-center font-medium leading-none'
      ];

      // Size classes
      const sizeClasses = {
        small: 'text-xs px-1.5 py-0.5 min-w-[1rem] h-4',
        normal: 'text-sm px-2 py-1 min-w-[1.25rem] h-5',
        large: 'text-base px-2.5 py-1 min-w-[1.5rem] h-6',
        xlarge: 'text-lg px-3 py-1.5 min-w-[2rem] h-8'
      };
      classes.push(sizeClasses[this.size]);

      // Severity color classes
      const severityClasses = {
        primary: 'bg-blue-500 text-white',
        secondary: 'bg-gray-500 text-white',
        success: 'bg-green-500 text-white',
        info: 'bg-cyan-500 text-white',
        warning: 'bg-yellow-500 text-white',
        danger: 'bg-red-500 text-white'
      };
      classes.push(severityClasses[this.severity]);

      // Shape classes
      classes.push('rounded-full');

      // Disabled state
      if (this.badgeDisabled) {
        classes.push('opacity-50');
      }

      return classes.join(' ');
    }
  }
};
</script> 